<template>
  <v-container>
    <getting-data-overlay :is_loading="is_loading"
                          :loading_display_title="$vuetify.lang.t('$vuetify.checklist.getting_data_title')"></getting-data-overlay>
    <v-row v-if="!is_loading && !has_loading_error">
      <v-col cols="12">
        <v-list transition="fade-transition">
          <template v-for="(item, index) in checklist_items">
            <v-list-item class="checklist-item" :key="'item_'+index"
                         v-html=" $sanitize(
                                         item, {
                                            allowedTags: ['a'],
                                            allowedAttributes: {
                                            'a' : ['href']
                                         }
                                      })">
            </v-list-item>
            <v-divider
                v-if="index + 1 < checklist_items.length"
                :key="'divider_'+index"
            ></v-divider>
          </template>
        </v-list>
      </v-col>
    </v-row>
    <v-row v-if="has_loading_error">
      <v-col cols="12">
        <v-col cols="12" class="subtitle-1 text-center">
          {{ $vuetify.lang.t('$vuetify.errors.checklistNotLoaded') }}
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import LMRADataGetService from "../../../helpers/axios/LMRADataGetService";
//import appSettings from "../../../mixins/config/appSettings";
import GettingDataOverlayComponent from "../global/gettingDataOverlayComponent/GettingDataOverlayComponent";
import resourcesApi from "@/api/resources/resourcesApi";

export default {
  name: "checklisComponent",
  data: () => {
    return {
      is_loading: false,
      has_loading_error: false,
      checklist_items: []
    }
  },
  components: {
    gettingDataOverlay: GettingDataOverlayComponent
  },
  methods: {

    async get_checklist() {
      this.is_loading = true;
      let checklistId = await this.getCurrentProjectChecklistId()

      resourcesApi.getChecklist(checklistId).then((response) => {
        this.is_loading = false;
        this.prepare_items_for_list(response.data)
      }).catch(
          (error) => {
            this.is_loading = false;
            this.has_loading_error = true;
            window.console.error(error);
          }
      )
    },
    prepare_items_for_list(data) {
      if (!data.checklist_items || data.checklist_items.length <= 0) {
        this.has_loading_error = true;
        return false;
      }

      for (let item of data.checklist_items) {
        //console.log(item);
        if (item.display_value !== undefined) {
          //TODO ... RANGE CHECK ?
          let spaced_item = item.display_value.replace('<a', '&nbsp;<a');
          this.checklist_items.push(spaced_item);
        }
      }

      //console.log(this.checklist_items)
    },
    async getCurrentProjectChecklistId() {
      let activeSession = await this.$store.getters.getActiveWorkSession;
      /*window.console.log('ACTIVE SESSION');
      window.console.log(activeSession);*/
      return (
          activeSession !== undefined &&
          activeSession !== null &&
          typeof activeSession === 'object' &&
          activeSession.project_settings !== undefined &&
          activeSession.project_settings !== null &&
          activeSession.project_settings.linked_checklist_id !== undefined
      ) ? activeSession.project_settings.linked_checklist_id : null;
    },
  },
  async mounted(){
    if(!this.$workSessions.loading && !this.hasForceCloseWorkSessionFlag){
      await this.$workSessions.performSessionCheck();
      if(this.$auth.isAuthenticated){
        this.get_checklist();
      }
    }
  }
}
</script>

<style scoped>
.checklist-item {
  padding: 20px;
  min-height: 80px;
}
</style>